import {
  BaseballEventStatusId,
  BaseballIncidentId,
} from '@collector/sportsapi-client-legacy'

import { EventRelatedStatusConfig } from '../../../configuration'
import { otherStatusIncidents } from './consts'
import { getInningsConfig } from './utils'

export const eventRelatedStatusConfig: EventRelatedStatusConfig<
  BaseballEventStatusId,
  BaseballIncidentId
> = {
  [BaseballEventStatusId.NotStarted]: {
    possibleNextStatusIncidents: [
      BaseballIncidentId.FirstInningStarted,
      BaseballIncidentId.StartDelayed,
    ],
    otherStatusIncidents: otherStatusIncidents.filter(
      (incident) => incident !== BaseballIncidentId.NotStarted,
    ),
  },
  [BaseballEventStatusId.StartDelayed]: {
    possibleNextStatusIncidents: [BaseballIncidentId.FirstInningStarted],
    otherStatusIncidents,
  },
  [BaseballEventStatusId.DelayedByRain]: {
    possibleNextStatusIncidents: [BaseballIncidentId.FirstInningStarted],
    otherStatusIncidents,
  },
  ...getInningsConfig(),
}
